module.exports = __webpack_public_path__ + "static/media/logo-kkv.63c23293.svg";